<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="phoneNum" placeholder="请输入电话号码" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="nickName" placeholder="请输入用户名称" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="gender" placeholder="请选择用户性别" clearable @change="onSearch">
          <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select class="s_input" v-model="userLevel" placeholder="请选择用户等级" clearable @change="onSearch">
          <el-option v-for="item in userLevelOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select class="s_input" v-model="userPermission" placeholder="是否免费用户" clearable @change="onSearch">
          <el-option v-for="item in userPermissionOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="nickName" label="用户昵称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="gender" label="用户性别">
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">女</span>
              <span v-if="scope.row.gender == 1">男</span>
              <span v-if="scope.row.gender == 2">未知</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phoneNum || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userLevel" label="用户等级">
            <template slot-scope="scope">
              <span v-if="scope.row.userLevel == 2">大团长</span>
              <span v-if="scope.row.userLevel == 1">普通用户</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="freeFlag" label="免费用户">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.freeFlagSwitch" inactive-color="#E2E2E2" :key="scope.row.userId"
                @change="handleChangeFreeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-button class="btn" type="primary" plain @click="handleGrade(scope.row)"
                v-if="scope.row.userLevel == 1">等级调整</el-button>
              <el-button class="btn" type="primary" plain @click="handleSubordinate(scope.row)"
                v-if="scope.row.userLevel == 2">下级用户</el-button>
              <el-button class="btn" type="" plain @click="handleSeparateAccounts(scope.row)"
                v-if="scope.row.userLevel == 2">分账设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="分账设置" :visible.sync="separateAccountsVisible">
      <div style="display: flex;justify-content: center;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
          <el-form-item label="汇付商户号：" prop="merId">
            <el-input v-model.trim="ruleForm.merId" placeholder="请输入汇付商户号"></el-input>
          </el-form-item>
          <el-form-item label="费率(%)：" prop="feeRate">
            <div style="display: flex;align-items: center;">
              <el-input-number v-model="ruleForm.feeRate" placeholder="请输入费率(%)" :min="0.00" :max="100" :precision="2"
                :step="0.1"></el-input-number>
              <el-tooltip style="margin-left: 10px;" effect="dark" content="范围值为 0%~100%" placement="right">
                <i class="el-icon-warning" style="color: #F56C6C;"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="提成比例(%)：" prop="commissionRate">
            <div style="display: flex;align-items: center;">
              <el-input-number v-model="ruleForm.commissionRate" placeholder="请输入提成比例(%)" :min="0.00" :max="20"
                :precision="2" :step="0.1"></el-input-number>
              <el-tooltip style="margin-left: 10px;" effect="dark" content="范围值为 0%~20%" placement="right">
                <i class="el-icon-warning" style="color: #F56C6C;"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      separateAccountsVisible: false,
      nickName: "",//姓名
      userCode: "",//用户编号
      gender: "",//性别
      phoneNum: "",
      tableData: [],
      genderOptions: [
        { value: "0", label: "女" },
        { value: "1", label: "男" },
        { value: "2", label: "未知" },
      ],
      userLevel: '',//等级
      userLevelOptions: [
        { value: "2", label: "大团长" },
        { value: "1", label: "普通用户" },
      ],
      userPermission: '',//权限
      userPermissionOptions: [
        { value: "0", label: "付费用户" },
        { value: "1", label: "免费用户" },
      ],
      // 分账设置
      ruleForm: {
        merId: null,
        feeRate: null,
        commissionRate: null,
      },
      rules: {
        merId: [
          { required: true, message: '请输入汇付商户号', trigger: 'blur' },
          // { min: 3, max: 11, message: '长度在 3 到 11 个字符', trigger: 'blur' },
          {
            pattern: /^[1-9]\d*$/,
            message: '请输入正确的汇付商户号',
            trigger: 'blur'
          }
        ],
        feeRate: [
          { required: true, message: '请输入费率(%)', trigger: 'blur' },
        ],
        commissionRate: [
          { required: true, message: '请输入提成比例(%)', trigger: 'blur' },
        ],

      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.userInfoList, {
          params: {
            gender: this.gender || null,
            phoneNum: this.phoneNum || null,
            nickName: this.nickName || null,
            userCode: this.userCode || null,
            userLevel: this.userLevel || null,
            freeFlag: this.userPermission || null,//是否免费：0否；1是
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list.map((item) => {
            return {
              ...item,
              freeFlagSwitch: item.freeFlag == 0 ? false : true//false：免费，true：付费
            }
          }) || []
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 等级调整
    handleGrade(row) {
      this.$confirm('此操作将对该用户升级为大团长, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$api.userChangeLevel, {
            userId: row.userId,
            userLevel: row.userLevel == 1 ? 2 : 1,
          })
          .then(res => {
            if (res.code == 100) {
              this.$message({
                type: 'success',
                message: '调整成功!'
              });
              this.getRequestList()
            }

          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消调整'
        });
      });
    },
    // 用户权限调整
    handleChangeFreeStatus(row) {
      const permission = row.freeFlag == 0 ? '免费' : '付费'
      this.$confirm(`此操作将对该用户权限调整为${permission}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$api.userChangeFreeFlag, {
            userId: row.userId,
            freeFlag: row.freeFlag == 0 ? 1 : 0,
          })
          .then(res => {
            if (res.code == 100) {
              this.$message({
                type: 'success',
                message: '调整成功!'
              });
              this.getRequestList()
            }
          })
          .catch(err => {
            this.$set(row, "freeFlagSwitch", !row.freeFlagSwitch)
            this.$message.error(err.desc)
          })
      }).catch(() => {
        this.$set(row, "freeFlagSwitch", !row.freeFlagSwitch)
        this.$message({
          type: 'info',
          message: '已取消调整'
        });
      });
    },
    // 下级用户
    handleSubordinate(row) {
      this.$router.push({ name: 'subordinateDet', query: { userId: row.userId, } })
    },
    // 分账设置
    handleSeparateAccounts(row) {
      // console.log('分账设置', row);
      this.$axios
        .get(this.$api.getUserMerchant, {
          params: {
            userId: row.userId,
          },
        })
        .then(res => {
          const { code, result } = res
          if (code == 100) {
            if (result.id == null) {
              // 首次
              this.ruleForm = result
              this.$set(this.ruleForm, 'feeRate', undefined)
              this.$set(this.ruleForm, 'commissionRate', undefined)
            } else {
              // 编辑
              this.ruleForm = result
            }
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
      this.separateAccountsVisible = true
    },
    // 提交分账设置
    handleSubmitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log('提交分账设置', this.ruleForm);
          this.$axios
            .post(this.$api.merchantSet, {
              bizId: this.ruleForm.userId,
              commissionRate: this.ruleForm.commissionRate,
              feeRate: this.ruleForm.feeRate,
              id: this.ruleForm.id || null,
              merId: this.ruleForm.merId,
            })
            .then(res => {
              const { code } = res
              if (code == 100) {
                this.$message({
                  type: 'success',
                  message: '设置成功!'
                });
                this.separateAccountsVisible = false
                this.getRequestList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消提交分账设置
    handleCancel() {
      // console.log('取消提交分账设置', row);
      this.separateAccountsVisible = false
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields();
    },

    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {

  ::v-deep .el-input-number {
    width: 100%;
  }

  ::v-deep .el-input-number__decrease {
    border-radius: 10px 0 0 10px;
  }

  ::v-deep .el-input-number__increase {
    border-radius: 0 10px 10px 0;
  }
}
</style>
